import { createRef, useCallback, useEffect, useRef, useState } from 'react'

export function useResizableContainer() {
  const [isDocumentLoaded, setIsDocumentLoaded] = useState(false)
  const [containerWidth, setContainerWidth] = useState<number>(0)
  const pageRefs = useRef<React.RefObject<HTMLDivElement>[]>([])

  const initPagesOnDocumentLoad = useCallback((numPages: number) => {
    // Initialize refs array for all pages
    pageRefs.current = Array(numPages).fill(createRef<HTMLDivElement>())
    setIsDocumentLoaded(true)
  }, [])

  const updateSize = useCallback(() => {
    if (isDocumentLoaded && pageRefs.current[0]?.current) {
      setContainerWidth(pageRefs.current[0].current.offsetWidth - 32) // subtract padding
    }
  }, [isDocumentLoaded])

  useEffect(() => {
    updateSize()

    const observers: ResizeObserver[] = []
    pageRefs.current.forEach((pageRef) => {
      if (pageRef.current) {
        const resizeObserver = new ResizeObserver(() => updateSize())
        resizeObserver.observe(pageRef.current)
        observers.push(resizeObserver)
      }
    })

    return () => {
      observers.forEach((observer) => {
        observer.disconnect()
      })
    }
  }, [updateSize, isDocumentLoaded])

  return {
    pageRefs,
    containerWidth,
    initPagesOnDocumentLoad,
  }
}
